import { Station } from "@/entities/station";

const defaultLabel = (station: Station) => Station.getDisplayName(station, "stationCodeSuffixed");

export const getStationOptions = (stations: Station[], getBadgeLabel: (station: Station) => string = defaultLabel) =>
    stations.map((station) => ({
        label: Station.getDisplayName(station, "stationCodeSuffixed"),
        badgeLabel: getBadgeLabel(station),
        value: station.code,
    }));

export const getTreinserieOptions = (stations: string[]) =>
    stations.sort((a, b) => parseInt(a) - parseInt(b)).map((treinserie) => ({ label: treinserie, value: treinserie }));
